import { MenuItem, Select } from "@mui/material";
import { updateAppointmentProvider } from "apiHandler/actions";
import React, { useState } from "react";

const options = ["Not Started", "In-Progress", "Completed"];

const AdvChartSelector = ({ data, token }) => {
  // Initial value: fallback to options[0] if not matched
  const initialStatus = options.includes(data.adv_chart_status)
    ? data.adv_chart_status
    : options[0];

  const [status, setStatus] = useState(initialStatus);
  const [lastValidStatus, setLastValidStatus] = useState(initialStatus);

  const onChange = async (newStatus) => {
    setStatus(newStatus);

    const payload = {
      //   id: data.id,
      adv_chart_status: newStatus,
    };

    try {
      const response = await updateAppointmentProvider(payload, token);
      if (response && response?.status === "successfull") {
        setLastValidStatus(newStatus);
      } else {
        setStatus(lastValidStatus);
      }
    } catch (error) {
      console.log("error: ", error);
      setStatus(lastValidStatus);
    }
  };

  return (
    <Select
      sx={{ width: "100%", height: "100%" }}
      value={status}
      onChange={(e) => onChange(e.target.value)}
      variant="standard"
    >
      {options.map((s) => (
        <MenuItem key={s} value={s}>
          {s}
        </MenuItem>
      ))}
    </Select>
  );
};

export default AdvChartSelector;
